"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EthersContractWrapperBuilder_1 = require("./EthersContractWrapperBuilder");
var MockableEthersContractWrapperBuilder_1 = require("./MockableEthersContractWrapperBuilder");
/**
 * Putting "wrap" and "mock" methods directly in EthersContractWrapper or EtherContractWrapperList
 * was causing https://stackoverflow.com/a/44727578
 */
var WrapperBuilder = /** @class */ (function () {
    function WrapperBuilder() {
    }
    WrapperBuilder.wrap = function (contract) {
        return new EthersContractWrapperBuilder_1.EthersContractWrapperBuilder(contract, "full");
    };
    WrapperBuilder.mock = function (contract) {
        return new MockableEthersContractWrapperBuilder_1.MockableEthersContractWrapperBuilder(contract, "full");
    };
    WrapperBuilder.wrapLite = function (contract) {
        return new EthersContractWrapperBuilder_1.EthersContractWrapperBuilder(contract, "lite");
    };
    WrapperBuilder.mockLite = function (contract) {
        return new MockableEthersContractWrapperBuilder_1.MockableEthersContractWrapperBuilder(contract, "lite");
    };
    return WrapperBuilder;
}());
exports.default = WrapperBuilder;
//# sourceMappingURL=WrapperBuilder.js.map